import React from "react";
import "./AccountVerified.css";

const AccountVerified = () => {
  return (
    <div className="account-verified-container">
      <div className="account-verified-card">
        {/* Header */}
        <div className="header-account-verified">
          <div className="header-content">
            <h2>Account Verified!</h2>
            <p>Welcome to Noptionwave</p>
          </div>
        </div>

        {/* Body */}
        <div className="body">
          <div className="icon-container">
            <div className="check-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <h3>
            Congratulations, <span className="username">User!</span>
          </h3>

          <p className="text">
            Your email has been successfully verified and your account is now active.
          </p>
          <p className="text">
            You can now login to access all features and start exploring!
          </p>

          {/* Login Button */}
          <a href="/login" className="login-btn">
            Login to Your Account
          </a>

          {/* Steps */}
          <div className="steps">
            <ul>
              <li>
                <span className="step-number">1</span> Login using your email and password
              </li>
              <li>
                <span className="step-number">2</span> Complete your profile details
              </li>
              <li>
                <span className="step-number">3</span> Start your trading journey 🚀
              </li>
            </ul>
          </div>

          <p className="support-text">
            Need help? Contact us at{" "}
            <a href="mailto:support@noptionwave.com">support@noptionwave.com</a>
          </p>
        </div>

        {/* Footer */}
        <div className="footer">
          <p>© 2025 Noptionwave. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default AccountVerified;
